module.exports = __webpack_public_path__ + "img/ap-logo.64684f75.jpg";